module.exports = __webpack_public_path__ + "img/1F1F0-1F1FC.e496cd80.svg";